import React from "react";
import { useActivitiesData } from "./ActivitiesDataContext";

const ActivitiesAsyncGate = {
  fields: {
    loading: { type: "slot" as const },
    error: { type: "slot" as const },
    content: { type: "slot" as const },
    loadingMessage: { type: "text" as const },
  },
  defaultProps: {
    loading: [
      { type: "LoadingSpinner", props: { id: "LoadingSpinner-default", message: "Loading your activities…" } },
    ] as any[],
    error: [] as any[],
    content: [] as any[],
    loadingMessage: "Loading your activities…",
  },
  render: (props: any) => {
    const {
      loading: LoadingSlot,
      error: ErrorSlot,
      content: ContentSlot,
      loadingMessage,
    } = props as any;

    const { loading, error } = useActivitiesData();

    if (loading) {
      if (LoadingSlot) return <LoadingSlot />;
      return (
        <div className="flex items-center justify-center p-12">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4" />
            <span className="text-lg">{loadingMessage}</span>
          </div>
        </div>
      );
    }

    if (error) {
      if (ErrorSlot) return <ErrorSlot />;
      return (
        <div className="p-6 bg-red-50 border border-red-200 rounded text-red-800">
          {error}
        </div>
      );
    }

    const Content = ContentSlot || React.Fragment;
    return <Content />;
  },
};

export default ActivitiesAsyncGate;